import { render, staticRenderFns } from "./AIOptimizeReviewModal.vue?vue&type=template&id=7ca184ad&scoped=true"
import script from "./AIOptimizeReviewModal.vue?vue&type=script&lang=js"
export * from "./AIOptimizeReviewModal.vue?vue&type=script&lang=js"
import style0 from "./AIOptimizeReviewModal.vue?vue&type=style&index=0&id=7ca184ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca184ad",
  null
  
)

export default component.exports